import React from "react";
import Logo from "../../images/Logo-Original.svg";

/**
 * Branded GharPar logo loader (same visual language as GharParAdmin).
 *
 * visible — controlled show/hide (Redux loading / Suspense)
 * mode="global" — fixed soft full-app overlay
 * mode="inline"  — absolute within a relative parent
 *
 * Always pointer-events: none so it never blocks clicks.
 */
const GpLogoLoader = ({
  visible = true,
  label = "Loading",
  mode = "inline",
  size = "md",
}) => {
  if (!visible) return null;

  const isGlobal = mode === "global";
  const isSm = size === "sm";

  return (
    <div
      className={`gp-logo-loader${isGlobal ? " gp-logo-loader--global" : ""}${
        isSm ? " gp-logo-loader--sm" : ""
      }`}
      aria-busy="true"
      aria-live="polite"
      aria-label={label}
    >
      <style>{`
        .gp-logo-loader {
          position: absolute;
          inset: 0;
          z-index: 40;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none !important;
          background: rgba(251, 244, 239, 0.65);
          backdrop-filter: blur(2px);
          border-radius: inherit;
        }
        .gp-logo-loader--global {
          position: fixed;
          inset: 0;
          z-index: 1200;
          border-radius: 0;
          background: rgba(251, 244, 239, 0.55);
        }
        .gp-logo-loader,
        .gp-logo-loader * {
          pointer-events: none !important;
        }
        .gp-logo-loader__inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 14px;
        }
        .gp-logo-loader__mark {
          position: relative;
          width: 108px;
          height: 108px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .gp-logo-loader--sm .gp-logo-loader__mark {
          width: 64px;
          height: 64px;
        }
        .gp-logo-loader__ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 2px solid transparent;
          border-top-color: #e7523e;
          border-right-color: #f68d2f;
          animation: gp-logo-spin 0.9s linear infinite;
        }
        .gp-logo-loader__img {
          width: 72px;
          height: auto;
          max-height: 48px;
          object-fit: contain;
          animation: gp-logo-pulse 1.35s ease-in-out infinite;
        }
        .gp-logo-loader--sm .gp-logo-loader__img {
          width: 40px;
          max-height: 28px;
        }
        .gp-logo-loader__label {
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.4px;
          text-transform: uppercase;
          color: #9aa1ab;
          font-family: Poppins, sans-serif;
        }
        .gp-logo-loader--sm .gp-logo-loader__label {
          display: none;
        }
        @keyframes gp-logo-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes gp-logo-pulse {
          0%, 100% { opacity: 0.55; transform: scale(0.96); }
          50% { opacity: 1; transform: scale(1); }
        }
      `}</style>
      <div className="gp-logo-loader__inner">
        <div className="gp-logo-loader__mark">
          <span className="gp-logo-loader__ring" />
          <img
            className="gp-logo-loader__img"
            src={Logo}
            alt=""
            draggable={false}
          />
        </div>
        <div className="gp-logo-loader__label">{label}</div>
      </div>
    </div>
  );
};

export default GpLogoLoader;
